import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Status } from '@bcef/ia-shared';
import { Store } from '@ngrx/store';
import { first, map, tap } from 'rxjs';

import * as fromStore from '../store';

export const productListResolver: ResolveFn<boolean> = () => {
  const store = inject(Store);
  return store.select(fromStore.selectProductListStatus).pipe(
    tap((status) => {
      if (status === Status.INITIAL) {
        store.dispatch(fromStore.ProductListLoad());
      }
    }),
    map(() => true),
    first(),
  );
};
